<template>
  <vehicule-form title="NUEVO VEHICULO" schema="new" />
</template>

<script>
import VehiculeForm from "../../components/Forms/VehiculeForm.vue";

export default {
  components: { VehiculeForm },
};
</script>

<style></style>
